




































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine } from "@/utils/common";
const testingItem = namespace("testing-item");

@Component({})
export default class TestItemEdit extends Vue {
  @testingItem.Action getTestingTemplateDetail;
  emptyToLine = emptyToLine;
  get breadData() {
    return [
      { name: window._I18N.t("test.detection-template"), path: "/setting/test-template" },
      { name: window._I18N.t("setting.test-template-details") }
    ];
  }
  get newTestItemList() {
    return [{}, {}];
  }
  get checkTemplateId() {
    return this.$route.params.id;
  }
  created() {
    this.init();
  }
  testTemplateInfo: any = {};
  init() {
    this.getTestingTemplateDetail({
      checkTemplateCode: this.checkTemplateId
    }).then(data => {
      this.testTemplateInfo = data.data;
    });
  }
  testItemData: any = {};
}
